import DatabaseManagerStore from "./views/admin/DatabaseManager/DatabaseManagerStore";
import { UIStore } from "@intrasync/stores/features";
import { ServiceViewStore } from "@intrasync/react";
import BomExtractionViewStore from "./views/bom-extraction/BomExtractionViewStore";

// Import store lists from each view group
import projectManagementStoreList from "./views/projectManagement/viewStoresList";
import schedulingStoreList from "./views/scheduling/schedulingStoreList";
import inventoryAndFieldStoreList from "./views/inventoryAndField/inventoryAndFieldStoreList";
import inventoryStoreList from "./views/inventory/inventoryStoreList";
import dispatchStoreList from "./views/dispatch/dispatchStoreList";
import productionStoreList from "./views/production/productionStoreList";
import qualityControlStoreList from "./views/qualityControl/qualityControlStoreList";
import dashboardsStoreList from "./views/dashboards/dashboardsStoreList";
import administrationStoreList from "./views/administration/administrationStoreList";
import crmStoreList from "./views/crm/crmStoreList";
import productStoreList from "./views/product/productStoreList";
import purchasingStoreList from "./views/purchasing/purchasingStoreList";
import fieldReportingStoresList from "./views/fieldReporting/fieldReportingStoresList";
import pdfStoreList from "views/pdf/pdfStoreList";
import materialsStoreList from "./views/materials/materialsStoreList";
import yardManagementStoreList from "./views/yardManagement/yardManagementStoreList";
import operationsStoreList from "./views/operations/operationsStoreList";
import workflowsStoreList from "./views/workflows/workflowsStoreList";
import estimatingStoresList from "views/estimating/estimatingStoresList";
import payrollStoreList from "./views/payroll/payrollStoreList";

const appStores = [
  // Core stores
  { name: "databaseManagerStore", store: DatabaseManagerStore },
  { name: "uiStore", store: UIStore },
  // settingsStore is provided by the RootStore builtin (RootStore.mountStore).
  // Registering the same @intrasync/stores SettingsStore here only collided with
  // that reserved builtin key; removed in the 26.7.12 collision cleanup.
  { name: "serviceViewStore", store: ServiceViewStore },
  { name: "bomExtractionViewStore", store: BomExtractionViewStore },

  // View group stores
  ...estimatingStoresList,
  ...projectManagementStoreList,
  ...schedulingStoreList,
  ...inventoryStoreList, // @intrasync/inventory-management view stores
  ...yardManagementStoreList, // NTX screens beside @intrasync/yard-management
  ...inventoryAndFieldStoreList,
  ...dispatchStoreList,
  ...productionStoreList,
  ...qualityControlStoreList,
  ...dashboardsStoreList,
  ...administrationStoreList,
  ...crmStoreList,
  ...productStoreList,
  ...purchasingStoreList,
  ...fieldReportingStoresList,
  ...pdfStoreList,
  ...materialsStoreList,
  ...operationsStoreList,
  ...workflowsStoreList,
  ...payrollStoreList,
];

export default appStores;
